var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRestore = function SvgIconRestore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_restore_svg__ikony",
    viewBox: "0 0 22 22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_restore_svg__cls-1,.icon_restore_svg__cls-2{fill:#091f2c;stroke-width:0}.icon_restore_svg__cls-2{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01 1h1v1h-1zM11 4.02v3h5v10H6V8h2L4.5 4 1 8h2v12.02h16v-16z",
    className: "icon_restore_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    className: "icon_restore_svg__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    className: "icon_restore_svg__cls-2"
  })));
};
export default SvgIconRestore;